// extracted by mini-css-extract-plugin
module.exports = {"section":"G_section__hQrbV"};